import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20peach%20coral%20abstract%20gradient%20background%20with%20smooth%20flowing%20curves%2C%20minimalist%20geometric%20shapes%20in%20cream%20and%20peach%20tones%2C%20dreamy%20ethereal%20atmosphere%2C%20modern%20digital%20art%20style%2C%20elegant%20composition%20with%20soft%20lighting%2C%20no%20text&width=1800&height=1000&seq=hero-bg-peach&orientation=landscape"
          alt="8x8x水蜜桃官方平台"
          className="w-full h-full object-cover object-top"
          title="8x8x水蜜桃官方平台"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 md:px-6">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-md border border-background-50/30 mb-8">
          <i className="ri-sparkling-line text-accent-400 text-sm"></i>
          <span className="text-sm text-background-100">2026最新版火热上线</span>
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          甜蜜体验，尽在
          <br />
          <span className="text-primary-300">8x8x水蜜桃</span>
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          备受关注的热门内容平台入口，为您提供最新资源、使用指南、安全访问方式及常见问题解答，畅享极致数字体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/resources"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            <i className="ri-rocket-line mr-2"></i>
            立即探索
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-md text-background-100 rounded-full font-medium transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-50/30"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg mx-auto">
          {[
            { value: '100万+', label: '活跃用户' },
            { value: '50万+', label: '内容资源' },
            { value: '99.9%', label: '服务可用率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}